import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { DescriptionOutlined as DocumentIcon } from "@mui/icons-material";
import AuditPlanUploadZone from "./AuditPlanUploadZone";

const VIEWER_HEIGHT = "min(800px, calc(100vh - 280px))";

const AuditPlanEmptyState = ({
  onUploadFile,
  uploading = false,
  isAuditorView = false,
}) => {
  const theme = useTheme();
  const customColors = theme.customColors || {};
  const borderMain = customColors.border?.main ?? "#E8EAED";
  const textSecondary = customColors.text?.secondary ?? "#6B7280";

  return (
    <Box sx={{ bgcolor: "#F3F4F6", p: 1 }}>
      <Box
        sx={{
          width: "100%",
          height: VIEWER_HEIGHT,
          maxHeight: VIEWER_HEIGHT,
          minHeight: "500px",
          borderRadius: "8px",
          border: "1px solid #E5E7EB",
          backgroundColor: "#F3F4F6",
          p: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            width: "100%",
            borderRadius: "8px",
            border: "1px solid #E5E7EB",
            backgroundColor: "#FFFFFF",
            overflow: "hidden",
          }}
        >
          {isAuditorView ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                width: "100%",
                height: "100%",
                minHeight: 400,
                p: 2,
              }}
            >
              <Box
                sx={{
                  backgroundColor: customColors.background?.tableRow ?? "#F3F4F6",
                  boxShadow: customColors.shadow?.card ?? "0 1px 3px rgba(0,0,0,0.1)",
                  border: `1px solid ${borderMain}`,
                  borderRadius: "12px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: 220,
                  maxWidth: 520,
                  width: "100%",
                  px: 3,
                  py: 4,
                  gap: 2,
                }}
              >
                <DocumentIcon
                  sx={{
                    color: customColors.icons?.secondary ?? textSecondary,
                    fontSize: 40,
                    mb: 0.5,
                  }}
                  aria-hidden
                />
                <Typography variant="h6" sx={{ textAlign: "center" }}>
                  No audit plan uploaded
                </Typography>
                <Typography variant="body2" sx={{ textAlign: "center", maxWidth: 360 }}>
                  An audit plan document has not been uploaded for this audit yet.
                </Typography>
              </Box>
            </Box>
          ) : (
            <AuditPlanUploadZone
              onFileSelect={onUploadFile}
              disabled={uploading}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default AuditPlanEmptyState;
